/**
 * Copyright 2023 Design Barn Inc.
 */

import type { DotLottieStateMachineCommonOptions } from '../common';
import { DotLottieStateMachineCommon } from '../common';

export class LottieStateMachine extends DotLottieStateMachineCommon {
  public constructor(options: DotLottieStateMachineCommonOptions) {
    super(options);
  }
}
